module.exports = __webpack_public_path__ + "static/bg-18fe02eacd1ab843400d893f285f23c3.jpg";